import React from "react";
import arrowRightIcon from "../../../assets/icon-right-arrow.svg";
import arrowLeftIcon from "../../../assets/icon-left-right.svg";
import { VisibilityContext } from "react-horizontal-scrolling-menu";

function Arrow({
  children,
  disabled,
  onClick
}: {
  children: React.ReactNode;
  disabled: boolean;
  onClick: VoidFunction;
}) {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      style={{
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        opacity: disabled ? "0" : "1",
        userSelect: "none",
        borderRadius: "50%",
        width: "30px",
        height: "30px",
        overflow: "hidden",
        boxShadow: "0px 2px 14px -7px rgba(0, 0, 0, 0.94)",
        marginTop: "10rem",
        marginBottom: "1rem",

        zIndex: "999"
      }}
    >
      {children}
    </button>
  );
}

export function LeftArrow() {
  const { isFirstItemVisible, scrollPrev, visibleItemsWithoutSeparators } =
    React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    !visibleItemsWithoutSeparators.length && isFirstItemVisible
  );
  React.useEffect(() => {
    // NOTE: detect if whole component visible
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isFirstItemVisible);
    }
  }, [isFirstItemVisible, visibleItemsWithoutSeparators]);

  return (
    <Arrow disabled={disabled} onClick={() => scrollPrev()}>
      <img
        src={arrowRightIcon}
        style={{ width: "10px", height: "10px" }}
        alt=""
      />{" "}
    </Arrow>
  );
}

export function RightArrow() {
  const { isLastItemVisible, scrollNext, visibleItemsWithoutSeparators } =
    React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    !visibleItemsWithoutSeparators.length && isLastItemVisible
  );
  React.useEffect(() => {
    if (visibleItemsWithoutSeparators.length) {
      setDisabled(isLastItemVisible);
    }
  }, [isLastItemVisible, visibleItemsWithoutSeparators]);

  return (
    <Arrow disabled={disabled} onClick={() => scrollNext()}>
      <img
        src={arrowLeftIcon}
        style={{ width: "10px", height: "10px" }}
        alt=""
      />{" "}
    </Arrow>
  );
}
